import styled from '@emotion/styled'
import { bkgdSakuraPetals, bkgdSakuraPetalsMobile, patternTransitionRidges } from '.'

export const TestimonialSectionWrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  background-image: url(${bkgdSakuraPetals});
  background-size: 1250px;
  background-repeat: repeat-x;
  background-position: 40% 70%;

  @media (max-width: 1010px) {
    grid-template-columns: 1fr;
    background-image: url(${bkgdSakuraPetals}), url(${bkgdSakuraPetals});
    background-size: 900px;
    background-position: -100% 30%, 400% 100%;
  }

  @media (max-width: 550px) {
    background-image: url(${bkgdSakuraPetalsMobile});
    background-size: 450px;
    background-position: 0% 125%;
    background-repeat: no-repeat;
  }
`

export const Ridges = styled.div`
  grid-column: 1 / -1;
  height: 50px;
  background-image: url(${patternTransitionRidges});
  background-size: 1500px;
  background-position: 100% 100%;
  margin-bottom: 60px;
`

export const LeftSection = styled.div`
  max-width: 600px;
  justify-self: end;
  padding-left: 36px;

  @media (max-width: 1010px) {
    padding: 0 24px 24px;
    justify-self: center;
  }
  @media (max-width: 676px) { padding: 0 36px 36px; }
`

export const Testimonials = styled.div`
  display: grid;
  gap: 32px;
  width: 500px;

  @media (max-width: 1010px) { justify-self: center; }
  @media (max-width: 550px) { width: 90%; }
`

export const Review = styled.img`
  width: 400px;

  @media (max-width: 550px) { width: 350px; }
`
